module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout",
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c('Menu', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "box-shadow": "0 1px 1px rgba(0,0,0,.08)"
    },
    attrs: {
      "mode": "horizontal"
    },
    on: {
      "on-menu-item-select": function($event) {
        _vm.onMenuItemSelect($event)
      }
    }
  }, [_c('div', {
    staticClass: "layout-side-left"
  }, [_c('i-button', {
    staticClass: "pantallas-header-btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.goToHome()
      }
    }
  }, [_c('Icon', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "type": "ios-keypad-outline",
      "size": "25",
      "color": "#afafb0"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pantallas-header-text"
  }, [_vm._v("Camapañas")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-center"
  }, [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "50px"
    },
    attrs: {
      "src": "/static/img/logo-pantallas.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout-side-right"
  }, [_c('Dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "on-click": function($event) {
        _vm.onDropdownClick($event)
      }
    }
  }, [_c('i-button', {
    staticClass: "pantallas-header-btn",
    attrs: {
      "type": "text"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "person",
      "size": "26",
      "color": "#afafb0"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pantallas-header-text mr5"
  }, [_vm._v(_vm._s(_vm.$store.state.user.nombre_completo))]), _vm._v(" "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b",
      "color": "#afafb0"
    }
  })], 1), _vm._v(" "), _c('Dropdown-menu', {
    slot: "list"
  }, [_c('Dropdown-item', {
    attrs: {
      "name": "profile"
    }
  }, [_c('span', {
    staticClass: "span-centered"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-cog-outline",
      "color": "#afafb0",
      "size": "22"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml5"
  }, [_vm._v("\n                                Mi Perfil\n                            ")])], 1)]), _vm._v(" "), _c('Dropdown-item', {
    attrs: {
      "name": "logout",
      "divided": ""
    }
  }, [_c('span', {
    staticClass: "span-centered"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-undo-outline",
      "color": "#afafb0",
      "size": "22"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml5"
  }, [_vm._v("\n                                Cerrar sesión\n                            ")])], 1)])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "main"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-copy"
  }, [_vm._v("\n        " + _vm._s(_vm.currentYear) + " © Pantallas\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62e0ca2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/Layout.vue
// module id = 643
// module chunks = 1